import * as React from "react"
import { Folio, FolioSearch, Header, MobileHeader } from "@components"
import { categoryData, posts } from "@types"
import { useState, useEffect } from "react"
import { Link, navigate } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"

interface PostsProps {
  folios: posts[]
}
let selectedName: string = ""

export const Posts = ({ folios }: PostsProps) => {
  // state for all categories names
  const [categories, setCategories] = useState<posts[]>()
  // state for all category folios
  const [allFoliosData, setAllFoliosData] = useState<categoryData[]>()
  // selected Data
  const [selectedData, setSelectedData] = useState<[]>()
  // state for view of folios
  const [boxSize, setBoxSize] = useState<number>(2)

  // method for latest record on top
  // const sortByReleaseDate = (dataArray: any) => {
  //   return dataArray.sort((a: any, b: any) => {
  //     // Convert releaseDate strings to Date objects for comparison
  //     const dateA: any = new Date(a.publishDate)
  //     const dateB: any = new Date(b.publishDate)

  //     // Compare dates
  //     return dateB - dateA
  //   })
  // }
  // // sorting data on date bases

  // merging all category data in one state
  const foliosData = folios.flatMap((allFolios: posts) =>
    allFolios.categoryData.map((folioData: categoryData) => ({
      ...folioData,
    }))
  )

  useEffect(() => {
    setAllFoliosData(foliosData)
    // all categories
    const foliosCategory = folios.flatMap((categories: posts) => categories)
    setCategories(foliosCategory)
  }, [])

  // method for selected category
  const selectedFolio = (categoryName: string) => {
    const filterData: posts[] = folios.filter(
      (folio: posts) => folio.categoryName === categoryName
    )
    selectedName = categoryName
    let selectedCategoryData: any = filterData.flatMap(
      (data: posts) => data?.categoryData
    )
    setSelectedData(selectedCategoryData)
    setAllFoliosData(selectedCategoryData)
  }
  // search category handler
  const categorySearchHandler = (e: string) => {
    if (e !== "") {
      const filterData: posts | any = folios?.filter(
        (item: posts) =>
          item?.categoryName?.toLowerCase()?.indexOf(e.toLowerCase()) !== -1
      )
      const filterFolios = filterData.flatMap((folios: posts) =>
        folios.categoryData?.map((item: categoryData) => ({ ...item }))
      )
      setAllFoliosData([...filterFolios])
      setCategories([...filterData])
    } else {
      setAllFoliosData(foliosData)
      if (selectedData) {
        setAllFoliosData(selectedData)
      }
      setCategories(folios)
    }
  }

  const handleCategoryClick = (path: string) => {
    // Navigate immediately
    navigate(path)
  }
  // mobile folio list
  const [isMobileFolio, setIsMobileFolio] = useState<boolean>(false)
  useEffect(() => {
    const mediaQuery: any = window.matchMedia("(min-width: 1280px)") // Adjust the min-width as per your XL breakpoint
    const handleMediaChange = (e: MediaQueryListEvent) => {
      setIsMobileFolio(e.matches) // Set to true if not in XL media
    }

    // Set initial state
    handleMediaChange(mediaQuery)

    // Add listener
    mediaQuery.addEventListener("change", handleMediaChange)
    // Cleanup listener on unmount
    return () => mediaQuery.removeEventListener("change", handleMediaChange)
  }, [])

  // obfuscate styles
  const MainContainer = styled.div`
    width: 100%;
  `
  return (
    <div>
      {/* <img src={generateImageUrl(data?.cardImage).width(200).url()} /> */}
      {/* <object className="w-10" type="image/svg+xml" data={folio?.icon?.asset?.url}>
                    Your browser does not support SVG
                  </object> */}
      {/* <img
                      className="w-full"
                      src={folio.icon.asset.url}
                      alt="folio-icons"
                    /> */}

      <div className="flex xl:flex-row flex-col items-stretch justify-between">
        <div className="xl:px-5 xl:w-[17%] w-full h-[28vh] xl:pt-3"></div>
        <div className="xl:px-5 xl:w-[17%] header-bg w-full fixed z-10 left-0 w-full xl:pt-3">
          <div className="px-3 w-full h-[98%] bg-regular border-linear xl:rounded-xl">
            <MobileHeader />
            <div className="xl:pt-4">
              <div className="w-40 hidden xl:block h-16">
                <Link to="/">
                  <StaticImage
                    className="w-full h-full"
                    src="../../images/visualfolio-logo.png"
                    alt="visual-folio-logo"
                  />
                </Link>
              </div>
              {/* ============= view-control-SVG's ============== */}
              <div className="flex xl:flex hidden xl:my-8 xl:my-3 gap-8 viewControl items-center justify-center xl:justify-start">
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setBoxSize(2)
                  }}
                >
                  <svg
                    className="hover:fill-[url(#paint0_linear_7_5)] fill-black"
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      className={` ${
                        boxSize === 2 ? "fill-[url(#paint0_linear_7_5)]" : " "
                      } `}
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M7.33333 12.2222C7.98164 12.2222 8.60339 12.4798 9.06182 12.9382C9.52024 13.3966 9.77778 14.0184 9.77778 14.6667V19.5556C9.77778 20.2039 9.52024 20.8256 9.06182 21.284C8.60339 21.7425 7.98164 22 7.33333 22H2.44444C1.79614 22 1.17438 21.7425 0.715961 21.284C0.257539 20.8256 1.2255e-07 20.2039 1.2255e-07 19.5556V14.6667C1.2255e-07 14.0184 0.257539 13.3966 0.715961 12.9382C1.17438 12.4798 1.79614 12.2222 2.44444 12.2222H7.33333ZM19.5556 12.2222C20.1723 12.222 20.7662 12.4549 21.2184 12.8743C21.6706 13.2936 21.9476 13.8684 21.9939 14.4833L22 14.6667V19.5556C22.0002 20.1723 21.7673 20.7662 21.3479 21.2184C20.9286 21.6706 20.3539 21.9476 19.7389 21.9939L19.5556 22H14.6667C14.05 22.0002 13.456 21.7673 13.0038 21.3479C12.5516 20.9286 12.2746 20.3539 12.2283 19.7389L12.2222 19.5556V14.6667C12.222 14.05 12.4549 13.456 12.8743 13.0038C13.2936 12.5516 13.8684 12.2746 14.4833 12.2283L14.6667 12.2222H19.5556ZM7.33333 14.6667H2.44444V19.5556H7.33333V14.6667ZM19.5556 14.6667H14.6667V19.5556H19.5556V14.6667ZM19.5556 1.2255e-07C20.1723 -0.000195041 20.7662 0.232719 21.2184 0.652052C21.6706 1.07138 21.9476 1.64614 21.9939 2.26111L22 2.44444V7.33333C22.0002 7.95004 21.7673 8.54403 21.3479 8.99623C20.9286 9.44842 20.3539 9.72541 19.7389 9.77167L19.5556 9.77778H14.6667C14.05 9.77797 13.456 9.54506 13.0038 9.12573C12.5516 8.70639 12.2746 8.13163 12.2283 7.51667L12.2222 7.33333V2.44444C12.222 1.82774 12.4549 1.23375 12.8743 0.781553C13.2936 0.329353 13.8684 0.0523642 14.4833 0.00611137L14.6667 1.2255e-07H19.5556ZM7.33333 1.2255e-07C7.95004 -0.000195041 8.54403 0.232719 8.99623 0.652052C9.44842 1.07138 9.72541 1.64614 9.77167 2.26111L9.77778 2.44444V7.33333C9.77797 7.95004 9.54506 8.54403 9.12573 8.99623C8.70639 9.44842 8.13163 9.72541 7.51667 9.77167L7.33333 9.77778H2.44444C1.82774 9.77797 1.23375 9.54506 0.781553 9.12573C0.329353 8.70639 0.0523642 8.13163 0.00611137 7.51667L1.2255e-07 7.33333V2.44444C-0.000195041 1.82774 0.232719 1.23375 0.652052 0.781553C1.07138 0.329353 1.64614 0.0523642 2.26111 0.00611137L2.44444 1.2255e-07H7.33333ZM19.5556 2.44444H14.6667V7.33333H19.5556V2.44444ZM7.33333 2.44444H2.44444V7.33333H7.33333V2.44444Z"
                      fill=""
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_7_5"
                        x1="0"
                        y1="11"
                        x2="22"
                        y2="11"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#F3B900" />
                        <stop offset="1" stopColor="#9F69FF" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setBoxSize(3)
                  }}
                >
                  <svg
                    className={` hover:fill-[url(#paint0_linear_7_5)] ${
                      boxSize === 3
                        ? "fill-[url(#paint0_linear_7_5)]"
                        : "fill-black"
                    } `}
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M8.8 2.2V6.6H13.2V2.2H8.8ZM15.4 2.2V6.6H19.8V2.2H15.4ZM15.4 8.8V13.2H19.8V8.8H15.4ZM15.4 15.4V19.8H19.8V15.4H15.4ZM13.2 19.8V15.4H8.8V19.8H13.2ZM6.6 19.8V15.4H2.2V19.8H6.6ZM6.6 13.2V8.8H2.2V13.2H6.6ZM6.6 6.6V2.2H2.2V6.6H6.6ZM8.8 13.2H13.2V8.8H8.8V13.2ZM2.2 0H19.8C20.3835 0 20.9431 0.231785 21.3556 0.644365C21.7682 1.05694 22 1.61652 22 2.2V19.8C22 20.3835 21.7682 20.9431 21.3556 21.3556C20.9431 21.7682 20.3835 22 19.8 22H2.2C1.012 22 0 21.01 0 19.8V2.2C0 1.61652 0.231785 1.05694 0.644365 0.644365C1.05694 0.231785 1.61652 0 2.2 0Z"
                      fill=""
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_7_5"
                        x1="0"
                        y1="11"
                        x2="22"
                        y2="11"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#F3B900" />
                        <stop offset="1" stopColor="#9F69FF" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setBoxSize(4)
                  }}
                >
                  <svg
                    className="hover:fill-[url(#paint0_linear_7_5)] fill-black"
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="22"
                    viewBox="0 0 29 22"
                    fill="none"
                  >
                    <path
                      className={` ${
                        boxSize === 4 ? "fill-[url(#paint0_linear_7_5)]" : " "
                      } `}
                      d="M0 0V22H28.6V0H0ZM2.2 2.2H6.6V6.6H2.2V2.2ZM8.8 2.2H13.2V6.6H8.8V2.2ZM15.4 2.2H19.8V6.6H15.4V2.2ZM22 2.2H26.4V6.6H22V2.2ZM2.2 8.8H6.6V13.2H2.2V8.8ZM8.8 8.8H13.2V13.2H8.8V8.8ZM15.4 8.8H19.8V13.2H15.4V8.8ZM22 8.8H26.4V13.2H22V8.8ZM2.2 15.4H6.6V19.8H2.2V15.4ZM8.8 15.4H13.2V19.8H8.8V15.4ZM15.4 15.4H19.8V19.8H15.4V15.4ZM22 15.4H26.4V19.8H22V15.4Z"
                      fill=""
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_7_5"
                        x1="0"
                        y1="11"
                        x2="22"
                        y2="11"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#F3B900" />
                        <stop offset="1" stopColor="#9F69FF" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
              {/* ============== category-list ================ */}
              <div className="flex justify-between items-center">
                <h1
                  onClick={() => {
                    setAllFoliosData(foliosData)
                    selectedName = ""
                  }}
                  className={` xl:my-3 my-2 cursor-pointer hover-text-gradient ${
                    selectedName === ""
                      ? "text-gradient-secondary font-semibold"
                      : "text-black"
                  }`}
                >
                  All Projects
                  <span>({foliosData?.length})</span>
                </h1>
                <div
                  onClick={() => setIsMobileFolio(!isMobileFolio)}
                  className="px-2 flex cursor-pointer items-center justify-center xl:hidden bg-btn bg-glass text-black rounded-md"
                >
                  <p
                    className={` transition-all duration-300 ease-in-out ${isMobileFolio ? "rotate-180" : ""}`}
                  >
                    ⌵
                  </p>
                </div>
              </div>
              {isMobileFolio && (
                <div
                  id="scroll"
                  className="flex xl:flex-col gap-4 xl:gap-1 xl:h-[67vh] flex-row xl:overflow-x-hidden xl:overflow-y-scroll overflow-x-scroll"
                >
                  {categories?.map((folio: posts, index: number) => (
                    <div
                      onClick={() =>
                        handleCategoryClick(`/category/${folio?.slug?.current}`)
                      }
                      // onClick={() => selectedFolio(folio?.categoryName)}
                      key={index}
                      className="flex xl:flex-row flex-col cursor-pointer hover-text-gradient text-black text-sm my-2 xl:ml-3 rounded-xl items-center gap-2"
                    >
                      <div className="w-5">
                        <div
                          className={`svg w-full ${
                            selectedName === folio.categoryName
                              ? " xl:fill-none"
                              : " fill-none"
                          }`}
                          dangerouslySetInnerHTML={{ __html: folio.icon }}
                        />
                      </div>
                      <div>
                        <p
                          className={` lg:whitespace-normal whitespace-nowrap ${
                            selectedName === folio.categoryName
                              ? "text-gradient-secondary font-semibold"
                              : "text-black"
                          }`}
                        >
                          {folio.categoryName}
                          <span>({folio.categoryData.length})</span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="lg:py-3 pt-3 xl:hidden">
              <FolioSearch categorySearchHandler={categorySearchHandler} />
            </div>
          </div>
        </div>
        {/* =============== header-and-folios ============ */}
        <div className="xl:w-[85%] w-full">
          <div className="px-2 xl:pr-5 pt-3 xl:pb-24"></div>
          <div className="px-2 hidden xl:block fixed z-[2] right-[2px] header-bg xl:top-0 xl:w-[83%] w-full xl:pr-5 pt-3 xl:pb-7 pb-3">
            <Header
              categorySearchHandler={categorySearchHandler}
              IsHeading={false}
              IsHomeIcon={false}
            />
          </div>

          <MainContainer>
            <Folio folios={allFoliosData} boxSize={boxSize} />
          </MainContainer>
        </div>
      </div>
    </div>
  )
}
